export enum MainRoutes {
  HOME = 'home',
  REVIEWS = 'reviews',
  LOCATIONS = 'locations',
  INSIGHTS = 'insights',
  AI_INSIGHTS = 'ai_insights',
  USERS = 'users',
  POSTS = 'posts',
  APPLE_MAPS = 'applemaps',
  GUIDE = 'guide',
  ERROR = 'error'
}

export enum ReviewInsightsChildRoutes {
  NUMBER_OF_REVIEWS = 'number-of-reviews',
  RATINGS = 'ratings',
  LOCATION_COMPARISON = 'location-comparison',
  RESPONDED_COMMENTED = 'responded-commented',
  RESPONSE_TIME = 'response-time',
  POST_TIME = 'post-time'
}

export enum CampaignsChildRoutes {
  DETAIL = 'post_detail',
  CREATE = 'create_post',
  EDIT = 'edit_post',
  DUPLICATE = 'duplicate_post',
  PLATFORMS = 'platforms'
}

export enum AppleMapsChildRoutes {
  OAUTH = 'oauth'
}

export enum UserPermission {
  viewUsers = 'view:users',
  manageUsers = 'manage:users',
  viewClients = 'view:clients',
  manageClients = 'manage:clients',
  viewLivd = 'view:livd',
  viewReviews = 'view:reviews',
  manageReviews = 'manage:reviews',
  viewLocations = 'view:locations',
  manageLocations = 'manage:locations',
  viewInsights = 'view:insights',
  manageCampaigns = 'manage:campaigns',
  viewCampaigns = 'view:campaigns'
}
